import {GridColDef} from '@mui/x-data-grid-pro'
import {columnFragments as C} from './Fragments'
import {officeColumnMap} from './officeColumnMap'

export const programLayout = (
  handleInputChange: (index: number, field: string, value: string) => void,
  activeTab: string,
  programName: string,
  officeCode: string
): GridColDef[] => {
  if (activeTab === '제외수용가') {
    return [C.check_date, C.customer_number, C.customer_info, C.now_check_info]
  }

  const officeColumns = officeColumnMap(programName, handleInputChange, activeTab, officeCode)
  return officeColumns[officeCode] || officeColumns.default
}
